import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RuleConfigViewComponent } from '../rule-config-view/rule-config-view.component';
import type { ActiveRulePackageInfo } from 'src/app/core/services/rules-api.service';

@Component({
  selector: 'app-active-package-panel',
  standalone: true,
  imports: [CommonModule, RuleConfigViewComponent],
  templateUrl: './active-package-panel.component.html',
})
export class ActivePackagePanelComponent {
  @Input() active: ActiveRulePackageInfo | null = null;
  @Input() lockedKeys: string[] = [];
  @Input() loading = false;
  @Input() empty = false;
  @Input() refreshing = false;

  @Output() refresh = new EventEmitter<void>();
}
